import { render, staticRenderFns } from "./section-custom.vue?vue&type=template&id=5d271980&"
import script from "./section-custom.vue?vue&type=script&lang=js&"
export * from "./section-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "section-custom.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section/section-custom.vue
// module id = 214
// module chunks = 0